import(/* webpackMode: "eager" */ "/app/src/app/auth/magic-link/page.tsx");
